/**
 * Smooth scroll to an element with offset for fixed header
 * @param elementId - The ID of the element to scroll to (without #)
 * @param offset - Additional offset in pixels (default: 100 for header + padding)
 */
export function smoothScrollToElement(elementId: string, offset: number = 100): void {
  const element = document.getElementById(elementId);
  if (!element) {
    console.warn(`Element with ID '${elementId}' not found`);
    return;
  }

  const elementTop = element.offsetTop;
  const scrollPosition = elementTop - offset;

  window.scrollTo({
    top: Math.max(0, scrollPosition),
    behavior: 'smooth'
  });
}

/**
 * Handle anchor link clicks with smooth scroll and offset
 * @param event - The click event
 * @param href - The href attribute (e.g., "/#chi-siamo")
 * @param offset - Additional offset in pixels (default: 100)
 */
export function handleAnchorClick(
  event: React.MouseEvent<HTMLAnchorElement>, 
  href: string, 
  offset: number = 100
): void {
  // Check if it's an anchor link to the same page
  if (href.startsWith('/#') || href.startsWith('#')) {
    event.preventDefault();
    
    const elementId = href.replace(/^\/?#/, '');
    
    // If we're not on the home page and the link is to home sections, navigate first
    if (href.startsWith('/#') && window.location.pathname !== '/') {
      window.location.href = href;
      return;
    }
    
    smoothScrollToElement(elementId, offset);
  }
}

/**
 * Auto-scroll to element on page load if hash is present in URL
 * @param offset - Additional offset in pixels (default: 100)
 */
export function handleHashOnLoad(offset: number = 100): void {
  if (typeof window === 'undefined') return;
  
  const hash = window.location.hash;
  if (hash && hash.length > 1) {
    // Wait for the page to fully load before scrolling
    setTimeout(() => {
      const elementId = hash.substring(1);
      smoothScrollToElement(elementId, offset);
    }, 100);
  }
}